import React from 'react';
import Routing from './Routing';

const Home = () => {

  return(
    <div>
      <Routing />
    </div>
  )
}

export default Home;